import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';
import global from '../../../common/utility/global';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { DOMICILIO_FISCAL } from '../../../common/types/tipoEstablecimientoType';
import { DNI, RUC } from '../../../common/types/tipoDocumentoType';
import { HABIDO } from '../../../common/types/condicionSunatType';
import { ACTIVO } from '../../../common/types/estadoContribuyenteType';
import { JURIFICA, NATURAL } from '../../../common/types/tipoPersonaType';
import establecimientoService from "../../../service/administracion/establecimientoService";

import empleadoService from '../../../service/administracion/empleadoService';
import centroCostoService from '../../../service/tesoreria/centroCostoService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import tipoPersonaService from '../../../service/administracion/tipoPersonaService';
import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import condicionSunatService from '../../../service/administracion/condicionSunatService';
import estadoContribuyenteService from '../../../service/administracion/estadoContribuyenteService';
import tipoRelacionService from '../../../service/administracion/tipoRelacionService';
import vendedorService from '../../../service/administracion/vendedorService';
import ubigeoService from '../../../service/integracion/ubigeoService';
import paisService from '../../../service/administracion/paisService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposEstablecimiento: [],
            tiposRelacion: [],
            vendedores: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            paises: [],
            centroCosto: [],
            filter: {
                idTipoPersona: 0,
                idTipoDocumento: 0,
                numeroDocumento: '',
                nombreRazonSocial: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            visibleDetalle: false,
            visibleFormEstablecimiento: false,
            formValues: this.fetchEmptyFormValues(),
            formValuesDetalle: this.fetchEmptyFormValuesDetalle(),
            formValuesEstablecimiento: this.fetchEmptyFormValuesEstablecimiento()
        }
    }

    handleClearFilters = () => {
        var filter = {
            idTipoPersona: 0,
            idTipoDocumento: 0,
            numeroDocumento: '',
            nombreRazonSocial: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await empleadoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Empleado.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await empleadoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Empleado.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await empleadoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await empleadoService.eliminar(values);
            else
                response = await empleadoService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idTipoPersona: NATURAL.ID,
            idTipoDocumento: DNI.ID,
            numeroDocumento: '',
            razonSocial: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correo: '',
            idEstadoContribuyente: ACTIVO,
            idCondicionSunat: HABIDO,
            idTipoRelacion: 0,
            idVendedor: 0,
            idTipoEstablecimiento: '',
            telefono: '',
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            idPais: 0,
            direccion: '',
            idCentrocosto:0,
            /******************/
            searchLoading: false,
            flagPersonaJuridica: false,
            flagPersonaNatural: true,
            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposEstablecimiento: [],
            tiposRelacion: [],
            vendedores: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            paises: [],
            centroCosto: [],

        }
    };

    fetchEmptyFormValuesDetalle = () => {
        return {
            idEntidad: 0,
            nombre: '',
            detalle: []
        }
    };

    fetchEmptyFormValuesEstablecimiento = () => {
        return {
            id: 0,
            nombre: '',
            idTipoEstablecimiento: 0,
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            direccion: '',
            telefono: '',
            tipoEstablecimientos: [],
            departamentos: [],
            provincias: [],
            distritos: []
        }
    };

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();

        formValues.tiposPersona = this.state.tiposPersona;
        formValues.paises = this.state.paises;
        formValues.tiposDocumento = this.state.tiposDocumento;
        formValues.condicionesSunat = this.state.condicionesSunat;
        formValues.estadosContribuyente = this.state.estadosContribuyente;
        formValues.tiposRelacion = this.state.tiposRelacion;
        formValues.vendedores = this.state.vendedores;
        formValues.departamentos = this.state.departamentos;
        formValues.tiposEstablecimiento = this.state.tiposEstablecimiento;
        formValues.centroCosto= this.state.centroCosto;

        this.setState({ visible: true, formValues });
    };

    handleNewEstablecimiento = () => {
        var formValuesEstablecimiento = this.fetchEmptyFormValuesEstablecimiento();
        formValuesEstablecimiento.tipoEstablecimientos = this.state.tiposEstablecimiento.filter(m => { return m.codigoSunat !== DOMICILIO_FISCAL.CODIGO });
        formValuesEstablecimiento.departamentos = this.state.departamentos;
        this.setState({ visibleFormEstablecimiento: true, formValuesEstablecimiento });
    };

    hanleBuscarEstablecimiento = async (value) => {
        const detalleFiltered = this.state.detalle.filter(m => ['', null, undefined].includes(value) ||
            global.formatSearch(m.nombre).match(global.formatSearch(value)));

        this.setState({
            formValuesDetalle: {
                ...this.state.formValuesDetalle,
                detalle: detalleFiltered
            }
        });
    };

    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
        this.setState({ formValues: { ...this.state.formValues, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });
        if (response.status === 200) {
            const provincias = await ubigeoService.provincias(response.data.idDepartamento);
            const distritos = await ubigeoService.distritos(response.data.idProvincia);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false,
                    provincias,
                    distritos
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno,
                    idCondicionSunat: { key: response.data.idCondicionSunat },
                    idEstadoContribuyente: { key: response.data.idEstadoContribuyente },
                    idDepartamento: { key: response.data.idDepartamento !== 0 ? response.data.idDepartamento : undefined},
                    idProvincia: { key: response.data.idProvincia !== 0 ? response.data.idProvincia : undefined},
                    idUbigeo: { key: response.data.idUbigeo !== 0 ? response.data.idUbigeo : undefined},
                    direccion: response.data.direccion,
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            });
        }
    };

    handleEdit = async (values) => {
        const response = await empleadoService.obtenerPorId(values.id);

        if (response !== undefined) {

          
            response.flagPersonaJuridica = response.codigoTipoPersona === JURIFICA.CODIGO ? true : false;
            response.flagPersonaNatural = response.codigoTipoPersona === NATURAL.CODIGO ? true : false;
            response.tiposEstablecimiento = this.state.tiposEstablecimiento;
            response.idCentroCosto = response.idCentroCosto;
            response.idTipoEstablecimiento=response.idEstablecimiento;

            response.paises = this.state.paises;
            response.tiposPersona = this.state.tiposPersona;
            response.tiposDocumento = this.state.tiposDocumento;
            response.condicionesSunat = this.state.condicionesSunat;
            response.estadosContribuyente = this.state.estadosContribuyente;
            response.tiposRelacion = this.state.tiposRelacion;
            response.vendedores = this.state.vendedores;
            response.departamentos = this.state.departamentos;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            response.centroCosto=this.state.centroCosto;
            this.setState({ visible: true, formValues: response });
        }
    };

    handleEditEstablecimiento = async (values) => {
        const response = await establecimientoService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.tipoEstablecimientos = this.state.tiposEstablecimiento.filter(m => { return m.codigoSunat !== DOMICILIO_FISCAL.CODIGO });
            response.departamentos = this.state.departamentos;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            this.setState({ visibleFormEstablecimiento: true, formValuesEstablecimiento: response });
        }
    };

    handleChangeForm = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritos: distritos ? distritos : []
                }
            });
        }

        if (property === "clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: [],
                    distritos: []
                }
            });
        }
        
        if (property === "idEstablecimiento") {

     
   /*          this.setState({
            formValues: {
              ...this.state.formValues,
              almacenes: almacenFilter ? almacenFilter : [],    
            },
          }); */

        }
    };

    handleChangeFormEstablecimiento = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValuesEstablecimiento: {
                    ...this.state.formValuesEstablecimiento,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValuesEstablecimiento: {
                    ...this.state.formValuesEstablecimiento,
                    distritos: distritos ? distritos : []
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await empleadoService.registrar(values);
            else
                response = await empleadoService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveEstablecimiento = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            values.idEntidad = this.state.formValuesDetalle.idEntidad;
            var response;
            if (values.id === 0)
                response = await establecimientoService.registrar(values);
            else
                response = await establecimientoService.modificar(values);

            if (response.status === 200) {
                var detalle = await establecimientoService.listarTodoPorIdEntidad(values.idEntidad);

                form.resetFields();
                this.setState({
                    detalle,
                    visibleFormEstablecimiento: false
                }, () => this.hanleBuscarEstablecimiento(''));

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleDeleteActiveEstablecimiento = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await establecimientoService.eliminar(values);
            else
                response = await establecimientoService.activar(values);

            if (response.status === 200) {
                var detalle = await establecimientoService.listarTodoPorIdEntidad(this.state.formValuesDetalle.idEntidad);
                this.setState({ detalle }, () => this.hanleBuscarEstablecimiento(''));
                message.success('Proceso realizado correctamente.');
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, empleadoService.paginacion);

        const tiposPersona = await tipoPersonaService.listar();
        const tiposDocumento = await tipoDocumentoService.listarExcluirPlaca();
        const condicionesSunat = await condicionSunatService.listar();
        const estadosContribuyente = await estadoContribuyenteService.listar();
        const departamentos = await ubigeoService.departamentos();
        const tiposRelacion = await tipoRelacionService.listar();
        const vendedores = await vendedorService.listar();
        const tiposEstablecimiento = await  establecimientoService.principales();;
        const paises = await paisService.listar();
        const tiposPersonaFilter = tiposPersona.filter(m=> m.id !== JURIFICA.ID);
        const centroCosto=await centroCostoService.listar();

        this.setState({
            loadingSource: false,
            tiposPersona: tiposPersonaFilter ? tiposPersonaFilter : [],
            tiposDocumento: tiposDocumento ? tiposDocumento : [],
            condicionesSunat: condicionesSunat ? condicionesSunat : [],
            estadosContribuyente: estadosContribuyente ? estadosContribuyente : [],
            tiposRelacion: tiposRelacion ? tiposRelacion : [],
            vendedores: vendedores ? vendedores : [],
            departamentos: departamentos ? departamentos : [],
            tiposEstablecimiento: tiposEstablecimiento ? tiposEstablecimiento : [],
            paises: paises ? paises : [],
            centroCosto: centroCosto ? centroCosto : []
        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Empleado"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    tiposPersona={this.state.tiposPersona}
                    tiposDocumento={this.state.tiposDocumento}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChange={this.handleChangeForm}
                    onBuscarPadronReducido={this.handleBuscarPadronReducido}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        )
    }
}